<div *ngIf="!isOrder(cart)">
  <h3 *cxFeature="'a11yCartSummaryHeadingOrder'" class="cx-summary-heading">
    {{ 'orderCost.orderSummary' | cxTranslate }}
  </h3>

  <div *cxFeature="'!a11yCartSummaryHeadingOrder'" class="cx-summary-heading">
    {{ 'orderCost.orderSummary' | cxTranslate }}
  </div>

  <div class="cx-summary-partials" *ngIf="cart">
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        {{ 'orderCost.value' | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ getValueWithoutDiscountsFormated() }}
      </div>
    </div>
    <div class="cx-summary-row cx-summary-row-discount" *ngIf="showTotalDiscounts(cart.totalDiscounts?.value)">
    <span>
      {{ 'orderCost.discount' | cxTranslate }}
    </span>
      <span>
      {{ cart.totalDiscounts?.formattedValue }}
    </span>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        {{ 'orderCost.total' | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ cart.totalPrice?.formattedValue }}
      </div>
    </div>
    <div class="cx-summary-row cx-summary-total">
      <div class="col-6 cx-summary-label">
        {{ 'orderCost.totalWeight' | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ getTotalWeight() }} Kg
      </div>
    </div>
    <sub class="tax-warn">
      *{{ 'orderCost.taxWarn' | cxTranslate }}
    </sub>
    <ng-template #cartWithoutNet>
      <div class="cx-summary-row">
        {{
          cart.totalPriceWithTax?.value !== cart.totalPrice?.value
            ? ('orderCost.grossTax' | cxTranslate)
            : ('orderCost.grossIncludeTax' | cxTranslate)
        }}
        {{ cart.totalTax?.formattedValue }}.
      </div>
    </ng-template>
  </div>

  <cx-applied-coupons
    [vouchers]="getVoucherData(cart.appliedVouchers)"
    [isReadOnly]="true"
  ></cx-applied-coupons>

</div>

<div class="cx-summary" *ngIf="isOrder(cart)">
  <h3 class="cx-summary-heading-order">
    {{ 'orderCost.orderSummary' | cxTranslate }}
  </h3>
  <hr/>

  <div class="cx-summary-row">
    <div class="col-6 cx-summary-label">
      {{ 'orderCost.subtotal' | cxTranslate }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{ cart.subTotal?.formattedValue }}
    </div>
  </div>

  <div class="cx-summary-row">
    <div class="col-6 cx-summary-label">
      {{ 'orderCost.shipping' | cxTranslate }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{ cart.deliveryCost?.formattedValue }}
    </div>
  </div>

  <div class="cx-summary-row">
    <div class="col-6 cx-summary-label">
      {{ 'orderCost.salesTax' | cxTranslate }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{ cart.totalTax?.formattedValue }}
    </div>
  </div>

  <div class="cx-summary-row">
    <div class="col-6 cx-summary-label">
      <strong>{{ 'orderCost.weight' | cxTranslate }}</strong>
    </div>
    <div class="col-6 cx-summary-amount" *ngIf="!isAsturias()">
      {{ cart.totalUnitCount }} Kg
    </div>
    <div class="col-6 cx-summary-amount" *ngIf="isAsturias()">
      {{getWeightOrder(cart)}} Kg
    </div>
  </div>

  <div class="cx-summary-row total-bold">
    <div class="col-6 cx-summary-label">
      <strong>{{ 'orderCost.total' | cxTranslate }}</strong>
    </div>
    <div class="col-6 cx-summary-amount">
      <strong>{{ cart.totalPriceWithTax?.formattedValue }}</strong>
    </div>
  </div>

  <div class="cx-summary-row cx-summary-row-discount" *ngIf="showTotalDiscounts(cart.totalDiscounts?.value)">
    <span>
      {{ 'orderCost.discount' | cxTranslate }}
    </span>
    <span>
      {{ cart.totalDiscounts?.formattedValue }}
    </span>
  </div>

  <cx-applied-coupons
    [vouchers]="getVoucherData(cart.appliedVouchers)"
    [isReadOnly]="true"
  ></cx-applied-coupons>

</div>

